/** @file Sockets panel registration: sockets, their grip axes and the items held on them. */
import { rigPanel } from '../rigKit/rigPanel';
import { SocketsView } from './SocketsView';

/** Rig panel over socket.create / setPoints / equip / unequip / delete. */
export const panel = rigPanel('sockets', 'panels.sockets.title', SocketsView);
